import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/pro-solid-svg-icons/faExternalLinkAlt';

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { FileAClaimButton } from '../../../insurance/components/file-a-claim-button';
import { FormattedCurrency } from '../../../components/formatted-currency';
import { InsuranceProviders } from '../../../enums/insurance-providers';
import { LabeledRow } from '../../../fulfillment-planner/labeled-row';

import { messages } from '../../../fulfillment-planner/labeled-row/messages';
import style from './style.module.css';

const DEFAULT_INSURED_VALUE = {
  code: 'USD',
  value: 0,
};

export const Insurance = ({ insuranceProviderName = 'None', insuredValue = DEFAULT_INSURED_VALUE, showMdash = false }) => {
  const { code, value } = insuredValue;
  const provider = Object.values(InsuranceProviders).find((p) => p.name === insuranceProviderName) || {};

  return (
    <>
      <LabeledRow className={style.row} label={<FormattedMessage {...messages.insurance} />} labelClassName={style.label}>
        {showMdash && <span className={style.mdash}>&mdash;</span>}
        {!showMdash && (
          <>
            <span className={style['insurance-label']}>
              <FormattedMessage {...provider?.messageDescriptor} />
            </span>
            <FileAClaimButton insuranceProviderName={insuranceProviderName}>
              {({ url, open }) => (
                <Button href={url} onClick={open} theme='link'>
                  <FormattedMessage {...messages.fileAClaim} />
                  <FontAwesomeIcon className={style['claim-icon']} icon={faExternalLinkAlt} />
                </Button>
              )}
            </FileAClaimButton>
          </>
        )}
      </LabeledRow>
      {provider.insuranceProviderId !== InsuranceProviders.None.insuranceProviderId && (
        <LabeledRow className={style.row} label={<FormattedMessage {...messages.insureAmt} />} labelClassName={style.label}>
          <span className={style.info}>
            <FormattedCurrency currencyCode={code} value={value} />
          </span>
        </LabeledRow>
      )}
    </>
  );
};

Insurance.propTypes = {
  insuranceProviderName: PropTypes.string,
  insuredValue: PropTypes.shape({
    code: PropTypes.string,
    value: PropTypes.number,
  }),
  showMdash: PropTypes.bool,
};
